import { Box } from '@mui/material'
import styles from './index.module.scss'

/**
 * Outer frame of the landing composer: a canvas-toned ring around the white
 * input panel. Concentric radii — 24px outside, 22px inside.
 *
 * The context row rides inside the ring, separated by 4px on the top and sides.
 * Without one there is nothing to separate, so the shell goes flush (see
 * `.composerShellPlain`).
 */
export default function AiAskBarComposerShell({ contextRow = null, children }) {
  const className = [styles.composerShell, contextRow ? '' : styles.composerShellPlain]
    .filter(Boolean)
    .join(' ')

  return (
    <Box className={className}>
      {children}
      {contextRow}
    </Box>
  )
}
